import {lazyWithRetry} from '../../libs/ui/src';

export const SignUpPage = lazyWithRetry(() => import('./SignUpPage'));
